import { defineFcm } from '../shared/factory';

export const FCM_ONLY_FORWARD_AUTH_TOKEN_WHEN_AUTHENTICATED = defineFcm('only_forward_auth_token_when_authenticated')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		supportedGroups: { global: true },
		context: 'Session security',
		description:
			"When on, the middle-end sends the session's auth-token to backend services only for AUTHENTICATED sessions. IDENTIFIED sessions (e.g. a guest signer who typed an existing account's email) stop forwarding the token. Turn off to restore the previous behavior of forwarding any stored token.",
	});
